import { Component, AfterViewInit, ViewChild, ElementRef, HostListener } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { createPopper } from "@popperjs/core";
import { CookieService } from "ngx-cookie-service";

@Component({
  selector: "app-languages-dropdown",
  templateUrl: "./languages-dropdown.component.html",
})
export class LanguagesDropdownComponent implements AfterViewInit {

  constructor(
    private translate: TranslateService,
    private cookieService: CookieService
  ){}


  dropdownPopoverShow = false;
  @ViewChild("btnDropdownRef", { static: false }) btnDropdownRef: ElementRef;
  @ViewChild("popoverDropdownRef", { static: false })
  popoverDropdownRef: ElementRef;
  ngAfterViewInit() {
    createPopper(
      this.btnDropdownRef.nativeElement,
      this.popoverDropdownRef.nativeElement,
      {
        placement: "bottom-start",
      }
    );
  }
  toggleDropdown(event) {
    event.preventDefault();
    if (this.dropdownPopoverShow) {
      this.dropdownPopoverShow = false;
    } else {
      this.dropdownPopoverShow = true;
    }
  }
  // Listen for clicks on the document
  @HostListener('document:click', ['$event'])
  handleClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (
      this.dropdownPopoverShow &&
      !this.btnDropdownRef.nativeElement.contains(target) &&
      !this.popoverDropdownRef.nativeElement.contains(target)
    ) {
      this.dropdownPopoverShow = false;
    }
  }

  changeLanguage(lang){
    this.translate.use(lang)
    this.cookieService.set('lang', lang)
    // window.location.reload();
  }

}
